/**
 * @file: 层板编组
 * @author: xiaolong.huang@dmall.com
 */

import { init } from './init';
import { updateLayerGroupStausAsync } from './groupStatus';
import { layerLink, getGroupList } from './link';
import { groupAllSelect } from './groupAllSelect';
import { groupDisperse } from './groupDisperse';
import { groupPasteShelf } from './groupPasteShelf';

function updateLayerGroupStatus(): void {
    updateLayerGroupStausAsync();
}

export default {
    init,
    updateLayerGroupStatus,
    layerLink,
    getGroupList,
    groupAllSelect,
    groupDisperse,
    groupPasteShelf
}
